import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Hiring Manager & Secondary Contact Details\n          ")
], -1);
const _hoisted_5 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_6 = { class: "col-span-6" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", {
    for: "hiring_name",
    class: "block text-sm font-medium text-gray-700"
}, "Hiring manager name *", -1);
const _hoisted_8 = { class: "mt-1" };
const _hoisted_9 = ["value", "disabled"];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-blue-700" }, "*You can either type your name (surname then space then first\n                name) e.g. Bloggs Joe and select the person icon or you can\n                open the address book and search for your name (this is linked\n                to the email directory)", -1);
const _hoisted_11 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_12 = { class: "col-span-6" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", {
    for: "hiring_email",
    class: "block text-sm font-medium text-gray-700"
}, "Hiring manager email *", -1);
const _hoisted_14 = { class: "mt-1" };
const _hoisted_15 = ["value", "disabled"];
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, " Please be sure to provide the correct email address as further\n            communications, including copy contracts, will be issued to this\n            email account. If an incorrect email address is provided, there\n            could be a resulting Data Protection breach therefore it is\n            essential that the correct information is provided ", -1);
const _hoisted_17 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_18 = { class: "col-span-6" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("label", {
    for: "employee_name",
    class: "block text-sm font-medium text-gray-700"
}, "What is the employee name for your contact *", -1);
const _hoisted_20 = { class: "mt-1" };
const _hoisted_21 = ["value", "disabled"];
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n                *You can either type their name (surname then space then first\n                name) e.g. Bloggs Joe and select the person icon or you can\n                open the address book and search for their name (this is linked\n                to the email directory)\n            ", -1);
const _hoisted_23 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_24 = { class: "col-span-6" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", {
    for: "employee_email",
    class: "block text-sm font-medium text-gray-700"
}, "What is the their email? *", -1);
const _hoisted_26 = { class: "mt-1" };
const _hoisted_27 = ["value", "disabled"];
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n                Please be sure to provide the correct email address as further\n                communications, including copy contracts, will be issued to\n                this email account. If an incorrect email address is provided,\n                there could be a resulting Data Protection breach therefore it\n                is essential that the correct information is provided\n\n            ", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("input", {
                                id: "hiring_name",
                                type: "text",
                                name: "hiring_name",
                                value: _ctx.formData?.hiringManagerName,
                                disabled: _ctx.disableForm,
                                class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed"
                            }, null, 8, _hoisted_9)
                        ]),
                        _createTextVNode(),
                        _hoisted_10
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("input", {
                                id: "hiring_email",
                                type: "text",
                                name: "hiring_email",
                                value: _ctx.formData?.hiringManagerEmail,
                                disabled: _ctx.disableForm,
                                class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed"
                            }, null, 8, _hoisted_15)
                        ]),
                        _createTextVNode(),
                        _hoisted_16
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("input", {
                                id: "employee_name",
                                type: "text",
                                name: "employee_name",
                                value: _ctx.formData?.employeeName,
                                disabled: _ctx.disableForm,
                                class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed"
                            }, null, 8, _hoisted_21)
                        ]),
                        _createTextVNode(),
                        _hoisted_22
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("input", {
                                id: "employee_email",
                                type: "text",
                                name: "employee_email",
                                value: _ctx.formData?.employeeEmail,
                                disabled: _ctx.disableForm,
                                class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed"
                            }, null, 8, _hoisted_27)
                        ]),
                        _createTextVNode(),
                        _hoisted_28
                    ])
                ])
            ])
        ])
    ]));
}
